import { UnderlyingAssetDto } from "../../../screens/portfolio-info/types/UnderlyingAssetDto";
import { createAuthenticatedApiClient, headerValues } from "./AuthenticatedApiClient";

type ApiClient = ReturnType<typeof createAuthenticatedApiClient>;

export function createUnderlyingAssetApi(apiClient: ApiClient) {
    const getByName = async (name: string): Promise<UnderlyingAssetDto | null> => {
        try {
            const response = await apiClient.get<UnderlyingAssetDto | string>(
                "api/underlyingAssets",
                { params: { name } },
            );

            return typeof response?.data === "string"
                ? null
                : response?.data ?? null;
        } catch (error: any) {
            console.log(error);
            return null;
        }
    };

    const create = async (name: string): Promise<UnderlyingAssetDto | null> => {
        try {
            const response = await apiClient.post<UnderlyingAssetDto, { name: string }>(
                "api/underlyingAssets",
                { name },
                { headers: headerValues.appJson },
            );

            return response?.data ?? null;
        } catch (error: any) {
            console.log(error);
            return null;
        }
    };

    return {
        getByName,
        create,
    };
}
